import { useTranslation } from "react-i18next";
import { BadgeCheck } from "lucide-react";

export const VerificationHeader = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <h3 className="text-lg font-medium">
        {t('profile.personalInfo.verificationTitle')}
      </h3>
      <BadgeCheck className="h-5 w-5 text-blue-500" />
    </div>
  );
};